export class StickyHeader {
    constructor($header, scrollDelta = 5) {
        this.$header = $header;
        this.previousScrollPosition = 0;
        this.scrollDelta = scrollDelta;
        this.headerHeight = this.$header ? this.$header.clientHeight / 3 : 0;
        this.isScrolling = false;

        // Bind the scroll handler
        this.handleScroll = this.handleScroll.bind(this);

        // Initialize scroll listener
        window.addEventListener('scroll', this.handleScroll);
    }

    /**
     * Handles the scroll event using requestAnimationFrame
     */
    handleScroll() {
        if (!this.isScrolling) {
            window.requestAnimationFrame(() => {
                this.updateHeader();
                this.isScrolling = false;
            });
            this.isScrolling = true;
        }
    }

    /**
     * Updates the header classes based on scroll position
     */
    updateHeader() {
        if (!this.$header) return;

        const currentScroll = window.scrollY;

        if (Math.abs(this.previousScrollPosition - currentScroll) <= this.scrollDelta) return;

        if (currentScroll === 0) {
            this.$header.classList.remove('nav-down', 'nav-up');
        } else if (currentScroll > this.previousScrollPosition && currentScroll > this.headerHeight) {
            this.$header.classList.add('nav-down');
        } else {
            if (currentScroll + window.innerHeight < document.body.clientHeight) {
                this.$header.classList.add('nav-down');
            }
        }

        this.previousScrollPosition = currentScroll;
    }
}